import React from "react";
import ContainerTitle from "../components/system/ContainerTitle";
import CSVAppender from "../components/training/CSVAppender";
import DataReader from "../components/training/DataReader";
import DataTagging from "../components/training/DataTagging";

export default function Training() {
  return (
    <React.Fragment>
      <ContainerTitle title="Training Data" loading={false} />
      <div className="card mb-4">
        <div className="card-body">
          <p>
            This section is to load data into the system to train sentiment
            analysis engine(s).
          </p>
          <p>
            The functionality here allows you to feed data into your machine
            learning component by tagging it as 'negative', 'neutral',
            'positive'. We will also query <em>Amazon Comprehend </em>
            engine and incorporate its output into your input as well.
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <CSVAppender />
        </div>
        <div className="col-xl-12 col-md-12">
          <DataTagging />
        </div>
        <div className="col-xl-12 col-md-12">
          <DataReader />
        </div>
      </div>
    </React.Fragment>
  );
}
